import SelectOption from "../../domains/SelectOptions";

type Model = {
  id: string
  name: string
}

export function toSelectOptions<T extends Model>(
  list: T[],
): SelectOption[] {
  return list.map(item => ({
    title: item.name,
    value: item.id,
  }));
}
